// Local Storage Keys
export const LABS_KEY = 'pl_lab_features';
export const SETTINGS_KEY = 'pl-settings-store';
